<script setup lang="ts">
const { vacancy } = defineProps<{ vacancy: Vacancy }>()

const isDev = import.meta.dev

const url = computed(() => {
  if (!vacancy.importData) return null

  return vacancy.importData['data']?.url
})

const viewImportData = ref(false)

</script>

<template>
  <BaseCard v-if="isDev" class="p-8">
    <BaseHeading>Import info</BaseHeading>

    <div class="mt-4 flex gap-2">
      <BaseButton
        v-if="url"
        :to="url"
        target="_blank"
      >
        Bekijk in oude site
      </BaseButton>

      <BaseButton
        @click="viewImportData = !viewImportData"
      >
        Bekijk import data
      </BaseButton>
    </div>

    <ul v-if="vacancy.importData && vacancy.importData['data']">
      <li>Commitment: {{ vacancy.importData['data']['commitment'] }}</li>
      <li>
        Commitment frequency:
        {{ vacancy.importData['data']['commitment_frequency'] }}
      </li>
    </ul>

    <pre
      v-if="viewImportData"
      class="whitespace-pre-wrap"
    >
      {{ vacancy.importData }}
    </pre>
  </BaseCard>
</template>
